const r = {
  name: "PlayCircle",
  dimensions: { width: 22, height: 23 },
  content: `
  
        <path d="M11 21.75C16.5228 21.75 21 17.2728 21 11.75C21 6.22715 16.5228 1.75 11 1.75C5.47715 1.75 1 6.22715 1 11.75C1 17.2728 5.47715 21.75 11 21.75Z" stroke="currentColor" fill="none" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10 13.75L13 11.75L10 9.75L10 13.75Z" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    `
};
export {
  r as PlayCircle
};
